var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEnglish = function SvgIconEnglish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.747.257q0-.257.257-.257h1.954q.258 0 .257.257v17.486q0 .257-.257.257h-1.877q-.18 0-.309-.18L18.724 4.68q-.026-.077-.077-.051-.052 0-.052.077l.026 13.037q0 .257-.257.257H16.41q-.258 0-.258-.257V.257q0-.257.258-.257h1.902q.18 0 .309.18l8.023 13.14q.026.077.077.077.051-.025.051-.103zM12.742 1.877q0 .258-.257.257H3.357q-.103 0-.103.103v5.529q0 .102.103.103H9.63q.257 0 .257.257v1.62q0 .257-.257.257H3.357q-.103 0-.103.103v5.657q0 .103.103.103h9.128q.258 0 .257.257v1.62q0 .257-.257.257H1.042q-.257 0-.257-.257V.257Q.785 0 1.042 0h11.443q.258 0 .257.257z"
  })));
};
export default SvgIconEnglish;